import React, {
    useContext,
    useEffect,
    useState,
} from 'react';
import { useQuery, useMutation } from '@tanstack/react-query';

import { refetchBasketData } from "../queries/global";
import { NotificationContext, handleError } from '../context/NotificationContext';

import * as QUERIES from "../queries/query-functions";
import config from "../config/config";

import TicketTypeSelect from '../components/ticket-type-select';
import InfoCircle from '../svg/info-circle';

export default function BasketTicketItem (props) {
    const {notification, setNotification} = useContext(NotificationContext);

    const [inEditMode, setInEditMode] = useState(false);
    const [seatInfo, setSeatInfo] = useState(null);

    const { 
        data: priceListData,
    } = useQuery({
        queryKey: ['priceListData', props.ticket.instance.id],
        queryFn: () => QUERIES.getInstancePriceList(props.ticket.instance.id),
        refetchOnWindowFocus: false,
        retry: false,
        staleTime: 86400000,
        onError: (error) => {
            handleError(error.message, setNotification);
        },
    });

    const removeTicket = useMutation({
        mutationFn: (ticketsIdArray) => QUERIES.removeTickets(ticketsIdArray),
        onError: (error) => {
            handleError(error.message, setNotification);
        },
        onSuccess: () => {
            refetchBasketData();
        },
    })

    const handleRemoveSupplementary = () => {
        let ticketsIdArray = [];

        if(!props.isSupplementaryView) {
            ticketsIdArray.push(props.ticket.id)
        } else {
            ticketsIdArray = [...props.sublingSupplementary];
        }
        removeTicket.mutateAsync(ticketsIdArray);
    }

    const { data: seatStatusData } = useQuery({
        queryKey: ['seatStatusData', config.INSTANCE_ID],
        queryFn: QUERIES.getSeatData,
        retry: false
    });

    useEffect(() => {
        if (!seatStatusData?.info || !props.ticket?.seat) return;
    
        // Find out if there is extra info
        if (seatStatusData.info[props.ticket.seat.id]) {
            setSeatInfo(seatStatusData.info[props.ticket.seat.id]);
        }
    }, [seatStatusData]);

    return (
        <li className='basket-item__ticket-list--item'>
            <p className='basket-item__ticket-list--area'>
                {props.eventName ||
                    [props.ticket.planName, props.ticket.seatName]
                        .filter(Boolean)
                        .join(", ")
                }
                                
                {!props.isSupplementaryView ? (inEditMode ?
                    <TicketTypeSelect ticket={props.ticket} pricelist={priceListData} setInEditMode={setInEditMode} /> 
                    :
                    props.ticket.planName != props.ticket.ticketType.name &&
                        <span className='basket-item__ticket-list--type'>{!props.isSupplementaryView && props.ticket.ticketType.name}</span>
                    ): null
                }
            </p>

            { seatInfo &&                    
                    <div className="basket-item__ticket-list--seat-info basket-summary__item--seat-info">
                        <InfoCircle /> <p>{decodeURIComponent(seatInfo.priceBandId.replaceAll("+"," "))}</p>
                    </div>
                }

            {props.sublingSupplementary && 
                <p className='basket-item__ticket-list--amount'>
                    <span className="sr-only">Ticket amount</span>
                    {
                        props.sublingSupplementary.length
                    }
                </p>
            }

            <p className='basket-item__ticket-list--price'>
                <span className='basket-item__ticket-list--price__full'>
                    <span className="sr-only">Ticket price</span>
                    £{(props.ticket.total + props.ticket.discount).toFixed(2)}
                </span>
                {props.ticket.discount ?
                    <span className='basket-item__ticket-list--price__discount'>
                        <span className="sr-only">Ticket price with discount</span>
                        {/* -£{props.ticket.discount.toFixed(2)} */}
                        £{props.ticket.total.toFixed(2)}
                    </span>
                :null}
            </p>
            
            <div className='basket-item__ticket-list--amend-ticket'>
                {!props.isSupplementaryView && (
                    <button type="button" onClick={() => setInEditMode(!inEditMode)} className='btn--edit'>                        
                        <span className='sr-only'>{inEditMode ? 'Change ticket type' : 'Edit ticket type'}</span>
                        {inEditMode ? 'Done': 'Edit'}
                    </button>
                    )
                }

                <button type="button" disabled={removeTicket.isPending} onClick={handleRemoveSupplementary} className='btn btn--remove'>
                    Delete
                </button>
            </div>
        </li>
    )
}